export default "__VITE_ASSET__CRs4wg$E__"